<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    @onConfirm="confirm"
    :isConfirm="isConfirm"
    :width="width"
  >
    <div slot="content">
      <el-form ref="form" label-width="120px" :model="dataForm" :rules="editFormRules">
        <el-form-item label="名称：" prop="Name">
          <el-input placeholder="名称" v-model="dataForm.Name" clearable></el-input>
        </el-form-item>
        <el-form-item label="联系人：" prop="Contacts">
          <el-input placeholder="联系人" v-model="dataForm.Contacts" clearable></el-input>
        </el-form-item>
        <el-form-item label="电话号码：" prop="Phone">
          <el-input placeholder="电话号码" v-model="dataForm.Phone" clearable></el-input>
        </el-form-item>
        <el-form-item label="应急救护电话：" prop="RescuePhone">
          <el-input v-model="dataForm.RescuePhone" clearable placeholder="请输入应急救护"></el-input>
        </el-form-item>
        <el-form-item label="人道救助电话：" prop="AidPhone">
          <el-input v-model="dataForm.AidPhone" clearable placeholder="请输入人道救助"></el-input>
        </el-form-item>
        <el-form-item label="社会捐赠电话：" prop="DonationPhone">
          <el-input v-model="dataForm.DonationPhone" clearable placeholder="请输入社会捐赠电话"></el-input>
        </el-form-item>
        <el-form-item label="会员申请电话：" prop="MemberPhone">
          <el-input v-model="dataForm.MemberPhone" clearable placeholder="请输入会员申请电话"></el-input>
        </el-form-item>
        <el-form-item label="其他捐赠电话：" prop="VolunteerPhone">
          <el-input v-model="dataForm.VolunteerPhone" clearable placeholder="请输入其他捐赠"></el-input>
        </el-form-item>
        <el-form-item label="传真号码：" prop="EmergencyPhone">
          <el-input placeholder="传真号码" v-model="dataForm.EmergencyPhone" clearable></el-input>
        </el-form-item>
        <el-form-item label="邮政编码：" prop="PostCode">
          <el-input placeholder="邮政编码" v-model="dataForm.PostCode" clearable></el-input>
        </el-form-item>
        <el-form-item label="邮箱地址：" prop="Email">
          <el-input placeholder="邮箱地址" v-model="dataForm.Email" clearable></el-input>
        </el-form-item>
        <el-form-item label="技术支持：" prop="TechnicalSupport">
          <el-input placeholder="技术支持" v-model="dataForm.TechnicalSupport" clearable maxlength="200"></el-input>
        </el-form-item>
        <el-form-item label="官网网址：" prop="WebSite">
          <el-input placeholder="官网网址" v-model="dataForm.WebSite" clearable></el-input>
        </el-form-item>
        <el-form-item label="详情地址：" prop="Address">
          <el-input placeholder="地址" v-model="dataForm.Address" clearable></el-input>
        </el-form-item>
        <el-form-item label="红会类型：" prop="Type">
          <el-select v-model="dataForm.Type" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.label"
              :label="item.label"
              :value="item.label"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="经纬度：">
          <el-col :span="6">
            <el-input placeholder="请输入经纬度" v-model="Latandang" clearable></el-input>
          </el-col>
          <el-col :span="6" style="margin-left:10px;color:blue;text-decoration:underline">
            <a href="http://api.map.baidu.com/lbsapi/getpoint/" target="_blank">查询经纬度</a>
          </el-col>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null
    },
    formTitle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      editFormRules: {
        Name: [{ required: true, message: "不能为空", trigger: "blur" }],
        Contacts: [{ required: true, message: "不能为空", trigger: "blur" }],
        Phone: [{ required: true, message: "不能为空", trigger: "blur" }],
        EmergencyPhone: [
          { required: true, message: "不能为空", trigger: "blur" }
        ],
        PostCode: [{ required: true, message: "不能为空", trigger: "blur" }],
        // WebSite: [{ required: true, message: "不能为空", trigger: "blur" }],
        IsEnable: [{ required: true, message: "不能为空", trigger: "blur" }],
        Address: [{ required: true, message: "不能为空", trigger: "blur" }],
        Type: [{ required: true, message: "不能为空", trigger: "blur" }],
        RescuePhone: [{ required: true, message: "不能为空", trigger: "blur" }],
        AidPhone: [{ required: true, message: "不能为空", trigger: "blur" }],
        VolunteerPhone: [{ required: true, message: "不能为空", trigger: "blur" }],
        DonationPhone: [{ required: true, message: "不能为空", trigger: "blur" }],
        MemberPhone: [{ required: true, message: "不能为空", trigger: "blur" }],
        Email: [{ required: true, message: "不能为空", trigger: "blur" }],
        TechnicalSupport: [{ required: true, message: "不能为空", trigger: "blur" }],
      },

      isConfirm: false,
      center: {
        Lng: 116.404,
        Lat: 39.925
      },
      zoom: 16,
      keyword: "",
      location: "上海",
      isShowPanel: true,
      width: "50%",

      options: [
        {
          //value: '1',
          label: "省红十字会"
        },
        {
          //value: '2',
          label: "市红十字会"
        },
        {
          //value: '3',
          label: "区县红十字会"
        }
      ],
      value: "",
      Latandang: ""
    };
  },
  mounted() {
    this.joint();
  },
  computed: {},
  components: {
    OfDialog
  },
  methods: {
    //经纬度拼接
    joint() {
      if (this.dataForm.Lat && this.dataForm.Lng) {
        this.Latandang = this.dataForm.Lng + "," + this.dataForm.Lat;
      }
    },
    searchcomplete() {
      this.isShowPanel = false;
    },
    handler({ BMap, map }) {
      //lat21.898083,lng112.020364
      let point = new BMap.Point(this.dataForm.Lng, this.dataForm.Lat);
      if (this.dataForm.Lng == undefined) {
        point = new BMap.Point(116.404, 39.915);
        map.centerAndZoom(point, 15);
      } else {
        this.center.Lng = this.dataForm.Lng;
        this.center.Lat = this.dataForm.Lat;
        map.centerAndZoom(point, 15);
        let marker = new BMap.Marker(point); // 创建标注
        map.addOverlay(marker); // 将标注添加到地图中
        let opts = {
          panel: "panel", //检索结果面板
          enableAutoPan: true, //自动平移
          width: 200, // 信息窗口宽度
          height: 100, // 信息窗口高度
          title:
            "<span style='font-size:20px;color:#FF0000;background-color:#FFFFFF'>地址:</span>", // 信息窗口标题
          message: ""
          // searchTypes:[
          //     BMAPLIB_TAB_FROM_HERE, //从这里出发
          //     BMAPLIB_TAB_SEARCH,   //周边检索
          //     BMAPLIB_TAB_TO_HERE,  //到这里去
          // ]
        };

        let infoWindow = new BMap.InfoWindow(this.dataForm.Address, opts); // 创建信息窗口对象
        // marker.addEventListener("click", function(){
        //     map.openInfoWindow(infoWindow, point); //开启信息窗口
        // });
        map.openInfoWindow(infoWindow, point);
      }
    },
    getClickInfo(e) {
      this.center.Lng = e.point.lng;
      this.center.Lat = e.point.lat;
      this.dataForm.Lng = e.point.lng;
      this.dataForm.Lat = e.point.lat;
    },

    cancel() {
      this.$emit("formCallBack", null);
    },
    confirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.isConfirm = true;
          this.dataForm.IsEnable = 0;
          var Latandang = this.Latandang.split(",");
          this.dataForm.Lng = Latandang[0];
          this.dataForm.Lat = Latandang[1];
          let params = Object.assign({}, this.dataForm);
          api.saveConnection(params)
            .then(rep => {
              this.isConfirm = false;
              if (rep.data.Code === 0) {
                this.$message({
                  message: "提交成功",
                  type: "success"
                });
                this.$emit("formCallBack", params);
              } else {
                this.$message({
                  message: rep.data.Message,
                  type: "error"
                });
              }
            })
            .catch(e => {
              this.isConfirm = false;
              this.$message({
                message: e.toString(),
                type: "error"
              });
            });
        }
      });
    }
  }
};
</script>

<style scoped>
.map {
  width: 50%;
  height: 300px;
}

.more_panel {
  text-align: center;
  font-size: 12px;
  color: #2878ff;
  padding-top: 10px;
}

.el-col >>> .el-col-4 {
  margin-right: 10px;
}
</style>
